type HistoryStatusI18n = {
  'com.streamlain.streamlain.history.queued': () => string;
  'com.streamlain.streamlain.history.running': () => string;
  'com.streamlain.streamlain.history.status-completed': () => string;
  'com.streamlain.streamlain.history.status-failed': () => string;
  'com.streamlain.streamlain.history.status-cancelled': () => string;
  'com.streamlain.streamlain.history.error-generic': () => string;
};

export type HistoryExecutionStatus =
  | 'running'
  | 'awaiting_external'
  | 'completed'
  | 'failed'
  | 'cancelled';

export type HistoryProcessStatus = 'running' | 'queued' | 'success' | 'error';

export function formatHistoryExecutionStatusLabel(
  t: HistoryStatusI18n,
  status: HistoryExecutionStatus,
  queued = false
): string {
  if (queued || status === 'awaiting_external') {
    return t['com.streamlain.streamlain.history.queued']();
  }

  switch (status) {
    case 'running':
      return t['com.streamlain.streamlain.history.running']();
    case 'completed':
      return t['com.streamlain.streamlain.history.status-completed']();
    case 'failed':
      return t['com.streamlain.streamlain.history.status-failed']();
    case 'cancelled':
      return t['com.streamlain.streamlain.history.status-cancelled']();
  }
}

export function formatHistoryProcessStatusLabel(
  t: HistoryStatusI18n,
  status: HistoryProcessStatus
): string {
  switch (status) {
    case 'queued':
      return t['com.streamlain.streamlain.history.queued']();
    case 'running':
      return t['com.streamlain.streamlain.history.running']();
    case 'success':
      return t['com.streamlain.streamlain.history.status-completed']();
    case 'error':
      return t['com.streamlain.streamlain.history.status-failed']();
  }
}

export function formatHistoryErrorMessage(
  t: HistoryStatusI18n,
  localizedMessage?: string | null
): string {
  return (
    localizedMessage ?? t['com.streamlain.streamlain.history.error-generic']()
  );
}
